import {
    HOUSEHOLD_RESILIENCE_LIST_FAIL,
    HOUSEHOLD_RESILIENCE_LIST_REQUEST,
    HOUSEHOLD_RESILIENCE_LIST_SUCCESS,
    HOUSEHOLD_RESILIENCE_CREATE_FAIL,
    HOUSEHOLD_RESILIENCE_CREATE_REQUEST,
    HOUSEHOLD_RESILIENCE_CREATE_SUCCESS,
    HOUSEHOLD_RESILIENCE_UPDATE_FAIL,
    HOUSEHOLD_RESILIENCE_UPDATE_REQUEST,
    HOUSEHOLD_RESILIENCE_UPDATE_SUCCESS,
    HOUSEHOLD_RESILIENCE_DELETE_FAIL,
    HOUSEHOLD_RESILIENCE_DELETE_REQUEST,
    HOUSEHOLD_RESILIENCE_DELETE_SUCCESS
} from "../Conistance/HouseholdResilienceConistance";

export const householdResilienceListReducer = (state = { loading: false, householdResilience: null, error: null }, action) => {
    switch (action.type) {
        case HOUSEHOLD_RESILIENCE_LIST_REQUEST:
            return { ...state, loading: true, error: null };
        case HOUSEHOLD_RESILIENCE_LIST_SUCCESS:
            return { loading: false, householdResilience: action.payload, error: null }
        case HOUSEHOLD_RESILIENCE_LIST_FAIL:
            return { loading: false, householdResilience: null, error: action.payload }
        default:
            return state;
    }
}

export const householdResilienceCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case HOUSEHOLD_RESILIENCE_CREATE_REQUEST:
            return { loading: true };
        case HOUSEHOLD_RESILIENCE_CREATE_SUCCESS:
            return { loading: false, success: true, resilienceLevel: action.payload }
        case HOUSEHOLD_RESILIENCE_CREATE_FAIL:
            return { loading: false, success: false, error: action.payload };
        default:
            return state;
    }
}

export const householdResilienceUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case HOUSEHOLD_RESILIENCE_UPDATE_REQUEST:
            return { loading: true };
        case HOUSEHOLD_RESILIENCE_UPDATE_SUCCESS:
            return { loading: false, success: true, resilienceLevel: action.payload }
        case HOUSEHOLD_RESILIENCE_UPDATE_FAIL:
            return { loading: false, success: false, error: action.payload }
        default:
            return state
    }
}

export const householdResilienceDeleteReducer = (success = '', action) => {
    switch (action.type) {
        case HOUSEHOLD_RESILIENCE_DELETE_REQUEST:
            return { loading: true }
        case HOUSEHOLD_RESILIENCE_DELETE_SUCCESS:
            return { loading: false, success: true }
        case HOUSEHOLD_RESILIENCE_DELETE_FAIL:
            return { loading: false, success: false };
        default:
            return success
    }
} 